/**
 * Spectator: Control's room board, read-only. Hidden backs only if the link
 * was made with spoilers (the server strips them otherwise).
 */
import { useEffect, useState } from 'react';
import { linkValid } from '../net/api.ts';
import { SessionScreen } from './SessionScreen.tsx';

export function SpectatorApp({ token }: { token: string }) {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [bad, setBad] = useState(false);
  useEffect(() => {
    fetch(`/api/whoami?t=${encodeURIComponent(token)}`)
      .then(async (r) => {
        if (!r.ok) return setBad(true);
        const j = (await r.json()) as { kind: string; sessionId: string };
        if (j.kind !== 'spectator') return setBad(true);
        setSessionId(j.sessionId);
      })
      .catch(() => setBad(true));
  }, [token]);
  if (bad) return <main className="fac-loading">This link has expired. Ask Control for a new one.</main>;
  if (!sessionId) return <main className="fac-loading muted">Opening the room…</main>;
  return <SessionScreen url={`/ws?t=${encodeURIComponent(token)}`} sessionId={sessionId} readonly check={() => linkValid(token)} />;
}
